import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Snackbar from 'material-ui/Snackbar';
import getTheme from '../MuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { connect } from 'react-redux';
var LLSnackbar = (_dec = connect(function (state, ownProps) {
  return {
    theme: state.theme
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(LLSnackbar, _Component);

  var _super = _createSuper(LLSnackbar);

  function LLSnackbar() {
    _classCallCheck(this, LLSnackbar);

    return _super.apply(this, arguments);
  }

  _createClass(LLSnackbar, [{
    key: "render",
    value: function render() {
      this.props.bodyStyle.backgroundColor = this.props.theme.colors.primaryColor;
      return /*#__PURE__*/React.createElement(Snackbar, {
        message: this.props.message,
        open: this.props.open,
        onRequestClose: this.props.onRequestClose,
        style: this.props.style,
        contentStyle: this.props.contentStyle,
        bodyStyle: this.props.bodyStyle,
        autoHideDuration: this.props.autoHideDuration,
        action: this.props.action
      });
    }
  }]);

  return LLSnackbar;
}(Component), _defineProperty(_class2, "propTypes", {
  message: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func,
  style: PropTypes.object,
  contentStyle: PropTypes.object,
  bodyStyle: PropTypes.object,
  autoHideDuration: PropTypes.number,
  action: PropTypes.node
}), _defineProperty(_class2, "defaultProps", {
  message: '',
  open: false,
  style: {},
  contentStyle: {},
  bodyStyle: {}
}), _temp)) || _class);
export { LLSnackbar as default };